import { render, staticRenderFns } from "./AddOrganizationToCampusModal.vue?vue&type=template&id=44982032&scoped=true&"
import script from "./AddOrganizationToCampusModal.vue?vue&type=script&lang=ts&"
export * from "./AddOrganizationToCampusModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44982032",
  null
  
)

export default component.exports